export interface ICustomer {
  id: number;
  uuid: string;
  name: string;
  addressLines: string[];
  address: string;
  telephone: string;
  postcode: string;
  endComment: string;
}

export const defaultCustomer: ICustomer = {
  id: 0,
  uuid: "",
  name: "",
  addressLines: [],
  address: "",
  telephone: "",
  postcode: "",
  endComment: "",
};
